import { render } from "./PageHeading.vue?vue&type=template&id=2828f101&scoped=true&ts=true"
import script from "./PageHeading.vue?vue&type=script&lang=ts"
export * from "./PageHeading.vue?vue&type=script&lang=ts"

import "./PageHeading.vue?vue&type=style&index=0&id=2828f101&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2828f101"]])

export default __exports__